import React from 'react';
import ReactDOM, { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";                                //icons
import './Base/Styles/PPF_dark.scss';
import './Base/Styles/PPF_light.scss';
import './Styles/styles.scss';


if (module.hot)module.hot.accept('./App')

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App style={{ overflow:'hidden' }} className={'animate__animated animate__fadeIn tableAnimate'} />);


reportWebVitals();
